module.exports = {"230714001":"乌伊岭街道","230714400":"上游林场","230714401":"美峰林场","230714402":"美林林场","230714403":"建新林场","230714404":"移山林场","230714405":"林海林场","230714406":"桔源经营所","230714407":"东克林林场","230714408":"福民林场","230714409":"阿廷河林场","230714410":"永胜经营所","230714411":"前卫林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230714.json
// module id = 695
// module chunks = 0